const LEAD_CONVERSION = "AW-18412523425/VXHxCLLOj-kcEKGf48tE";

export const trackLeadConversion = (transactionId) => {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", {
    send_to: LEAD_CONVERSION,
    ...(transactionId ? { transaction_id: transactionId } : {}),
  });
};
